import type { FC, PropsWithChildren } from 'react';
import { useEffect, useState } from 'react';

import { AddContextualData } from '@opendoor/observability';
import { useBrowserCompatibilityData } from 'shared/helpers/globals';

/**
 * Adds isMobile to the observability context based on user agent detection rather than breakpoints.
 * This is specifically for cases like prompting app downloads or sending SMS links where we need
 * accurate device detection regardless of viewport size.
 * https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent
 */
export const MobileDeviceContextualData: FC<PropsWithChildren> = ({ children }) => {
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const { userAgent, isOpendoorAppEvoWebView } = useBrowserCompatibilityData();

  useEffect(() => {
    if (/Mobi|Android/i.test(userAgent)) {
      setIsMobile(true);
    }
  }, [userAgent]);

  return (
    <AddContextualData data={{ isMobile, isMobileNativeWebView: isOpendoorAppEvoWebView }}>
      {children}
    </AddContextualData>
  );
};
